import { fixedsHeader, globalSearch, initFancyBox, initSearch } from "../common";
import { ImportBundle } from "../common/utils/utils";
import {handleSendInquiry} from "./utils/utils"
import _productAndService from "./page/productAndService";
import _aboutUs from "./page/aboutUs"
import _Case from "./page/case";
import _newsDetail from "./page/newsDetail";
import _sem from "./page/sem";
import _smo from "./page/socialMediaOperations"
import _classRoom from "./page/classRoom"
import _seo from "./page/seo";
import _ourService from "./page/ourService";
import _customerCase from "./page/customerCase";
_classRoom();
_smo();
_productAndService();
_Case();
_aboutUs();
_newsDetail();
_sem();
_seo();
_ourService();
_customerCase();
$(function () {
  if (window.innerWidth === 1350 || window.innerWidth === 412) {
    $(document).one("mousemove", () => {
      initFunction();
    });
    $(document).one("scroll", () => {
      initFunction();
    });
  } else {
    initFunction();
  }
});

let initFunction = () => {
  ImportBundle({ type: "css" }, ["https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css", "https://static.yigetechcms.com/public/css/bootstrap@4.6.2.min.css"]);
  ImportBundle({ type: "js" }, [
    {
      src: "https://static.yigetechcms.com/public/js/bootstrap@4.6.2.min.js",
    },
  ]);
  initFunction = () => {};
  initFancyBox();
  initSearch();
  initEvent();
  globalSearch();
};
function initEvent() {
  fixedsHeader('page__header');
  handleSendInquiry({
        formId: ".dialogForm #Teleport-Form",
        trigger: ".dialogForm #Teleport-Submit",
      });
}
